import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminMessages() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/contact-messages").then(({ data }) => setRows(data));
  useEffect(() => {
    load();
  }, []);
  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    await api.delete(`/admin/contact-messages/${id}`);
    toast.success("Deleted");
    load();
  };
  return (
    <div data-testid="admin-messages">
      <h1 className="font-display text-4xl text-ink mb-10">Messages</h1>
      <div className="space-y-4">
        {rows.map((r) => (
          <div key={r.id} className="bg-bg-surface border border-edge p-6">
            <div className="flex items-start justify-between mb-3">
              <div>
                <p className="text-ink font-medium">{r.name}</p>
                <p className="text-eyebrow text-ink-dim">
                  {r.email} {r.phone && ` · ${r.phone}`}
                </p>
              </div>
              <button onClick={() => remove(r.id)} className="text-ink-muted hover:text-bad">
                <Trash2 size={16} />
              </button>
            </div>
            {r.subject && <p className="text-eyebrow text-brand mb-2">{r.subject}</p>}
            <p className="text-ink-muted leading-relaxed text-sm whitespace-pre-wrap">{r.message}</p>
            <p className="text-eyebrow text-ink-dim mt-3">{r.created_at?.slice(0, 10)}</p>
          </div>
        ))}
        {rows.length === 0 && <p className="text-ink-muted">No messages yet.</p>}
      </div>
    </div>
  );
}
